import { BareActionContext } from 'vuex-typex'
import { FeedState } from '../state'
import { RootState } from '../..'
import feedStore from '../feed-store'

export default async function newStatement(context: BareActionContext<FeedState, RootState>)
{
    feedStore.commitSetFeedType({ type: 'statement-edit', columns: 2 })

    return
}
